import { initials } from "@/lib/cover";
import { cn } from "@web-shared/lib/utils";

/** A producer's picture, or their initials on the brand green. `live` rings
 * it in green — they are in a jam right now. */
export function Avatar({
  name,
  url,
  live = false,
  className,
}: {
  name: string;
  url: string | null | undefined;
  live?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "relative inline-flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/15 text-[11px] font-semibold text-primary",
        live && "ring-2 ring-primary ring-offset-2 ring-offset-background",
        className,
      )}
      title={live ? `${name} is jamming now` : undefined}
    >
      {url ? <img src={url} alt="" className="size-full object-cover" /> : initials(name)}
    </span>
  );
}
